import React, { Component } from "react";
import { Spinner } from "@blueprintjs/core";
import dayjs from "dayjs";
import { BASE_API } from "../../utils/constants";
import SaveBar from "../../components-fm/SaveBar";
import UISelect from "../../components-fm/UISelect";
import LayoutDualSidebar from "../../components-fm/LayoutDualSidebar";
import GameInfoGeneral from "./GameInfoGeneral";
import GameInfoPlayers from "./GameInfoPlayers";
import "./../../css/GameFormationPreview.scss";
import GameInfoStats from "./GameInfoStats";


const SUBSTITUTE_COUNT = 11
const PLAYERS_COUUNT = 11

const SISTEMS = [
    { id: '4-3-3', name: '4-3-3' },
    { id: '4-2-3-1', name: '4-2-3-1' },
]

const POSITIONS_433 = [
    { number: 1, top: '90%', left: 'calc(50% - 20px)', position: 'GK' },
    { number: 3, top: '67%', left: '20%', position: 'FS' },
    { number: 2, top: '67%', left: '74%', position: 'FD' },
    { number: 4, top: '68%', left: '58%', position: 'FCD' },
    { number: 5, top: '68%', left: '37%', position: 'FCS' },
    { number: 6, top: '50%', left: 'calc(50% - 20px)', position: 'MC' },
    { number: 7, top: '22%', left: '66%', position: 'AD' },
    { number: 8, top: '43%', left: '63%', position: 'ID' },
    { number: 9, top: '20%', left: 'calc(50% - 26px)', position: 'AC' },
    { number: 10, top: '43%', left: '32%', position: 'IS' },
    { number: 11, top: '22%', left: '27%', position: 'AS' },
];

const POSITIONS = {
    '4-3-3': [
        { number: 1, top: '90%', left: 'calc(50% - 20px)', position: 'GK' },
        { number: 3, top: '67%', left: '20%', position: 'FS' },
        { number: 2, top: '67%', left: '74%', position: 'FD' },
        { number: 4, top: '68%', left: '58%', position: 'FCD' },
        { number: 5, top: '68%', left: '37%', position: 'FCS' },
        { number: 6, top: '50%', left: 'calc(50% - 20px)', position: 'MC' },
        { number: 7, top: '22%', left: '66%', position: 'AD' },
        { number: 8, top: '43%', left: '63%', position: 'ID' },
        { number: 9, top: '20%', left: 'calc(50% - 26px)', position: 'AC' },
        { number: 10, top: '43%', left: '32%', position: 'IS' },
        { number: 11, top: '22%', left: '27%', position: 'AS' },
    ],
    '4-2-3-1': [
        { number: 1, top: '90%', left: 'calc(50% - 20px)', position: 'GK' },
        { number: 3, top: '67%', left: '20%', position: 'FS' },
        { number: 2, top: '67%', left: '74%', position: 'FD' },
        { number: 4, top: '68%', left: '56%', position: 'FCD' },
        { number: 5, top: '68%', left: '38%', position: 'FCS' },
        { number: 6, top: '52%', left: '56%', position: 'MC' },
        { number: 7, top: '35%', left: '68%', position: 'AD' },
        { number: 8, top: '52%', left: '38%', position: 'ID' },
        { number: 9, top: '20%', left: 'calc(50% - 26px)', position: 'AC' },
        { number: 10, top: '35%', left: 'calc(50% - 26px)', position: 'IS' },
        { number: 11, top: '35%', left: '25%', position: 'AS' },
    ],
}

export default class GameDetails extends Component {
    state = {
        team: null,
        game: null,
        players: [],
        originalGame: null,
        originalPlayers: [],
        isModified: false,
        loading: true,
        error: null,
        hoveredShirt: null,
        stats: { goals: [], cards: [], subs: [], appearances: [], goals_against: [] },
        originalStats: { goals: [], cards: [], subs: [], appearances: [], goals_against: [] },
        sistem: '4-3-3',
        // sistem: '4-2-3-1',

        contextPlayer: null,
        contextPos: null,
        // stats: { goals: [], cards: [], subs: [], appearances: [] },
        // originalStats: { goals: [], cards: [], subs: [], appearances: [] },
    };

    async componentDidMount() {
        const search = this.props.location?.search || window.location.search;
        const urlParams = new URLSearchParams(search);
        const teamSlug = urlParams.get("echipa");
        const { action, event_id, team_id } = this.getUrlParams();

        await this.fetchTeamBySlug(teamSlug);

        const wrapper = document.getElementById("echipaDashboard");
        if (wrapper) wrapper.classList.add("layout-full-width", "light-view");

        if (action === "edit" && event_id) {
            try {
                const res = await fetch(`${BASE_API}/api/event/${event_id}`);
                const data = await res.json();

                if (data?.event?.event_type === "game") {
                    const gamePlayersRes = await fetch(`${BASE_API}/api/game/${event_id}/players`);
                    const players = (await gamePlayersRes.json())?.players ?? [];

                    this.setState({
                        game: data.event,
                        originalGame: data.event,
                        players,
                        originalPlayers: players,
                        loading: false
                    });
                } else {
                    this.setState({ error: "Evenimentul nu este un meci", loading: false });
                }
            } catch (err) {
                this.setState({ error: err.message, loading: false });
            }
        } else if (action === "add" && team_id) {
            const today = new Date().toISOString().slice(0, 10);
            this.setState({
                game: {
                    event_date: today,
                    event_time: "17:00",
                    location: "",
                    opponent: "",
                    home_away: "acasa",
                    game_type: "amical",
                    team_id
                },
                originalGame: null,
                players: [],
                originalPlayers: [],
                loading: false
            });
        } else {
            this.setState({ error: "Parametri lipsă sau invalizi", loading: false });
        }

        // Stats
        const [gamePlayersRes, statsRes] = await Promise.all([
            fetch(`${BASE_API}/api/game/${event_id}/players`),
            fetch(`${BASE_API}/api/game/${event_id}/stats`) // <- endpointul tău nou
        ]);
        const players = (await gamePlayersRes.json())?.players ?? [];
        const statsPayload = (await statsRes.json()) || {};
        const stats = {
            goals: statsPayload.goals || [],
            cards: statsPayload.cards || [],
            subs: statsPayload.subs || [],
            appearances: statsPayload.appearances || [],
            goals_against: statsPayload.goals_against || [],
        };

        this.setState({
            players,
            originalPlayers: players,
            stats,
            originalStats: JSON.parse(JSON.stringify(stats)),
            loading: false
        });
    }

    componentWillUnmount() {
        const wrapper = document.getElementById("echipaDashboard");
        if (wrapper) wrapper.classList.remove("layout-full-width", "light-view");
    }

    getUrlParams = () => {
        const search = this.props.location?.search || window.location.search;
        const urlParams = new URLSearchParams(search);
        return {
            action: urlParams.get("action"),
            event_id: urlParams.get("event_id"),
            team_id: urlParams.get("team_id")
        };
    };

    fetchTeamBySlug = async (slug) => {
        try {
            const res = await fetch(`${BASE_API}/api/team-by-slug/${slug}`);
            const json = await res.json();
            if (!res.ok) throw new Error(json.error || "Eroare team-by-slug");
            this.setState({ team: json.team });
        } catch (err) {
            this.setState({ error: err.message });
        }
    };

    handlePlayerChange_v4 = (id, field, value, opts = {}) => {
        const players = this.state.players;

        // titular = are position, NU e rezervă și e "convocat"
        const startersCount = players.filter(
            p => p.is_substitute === 0 && p.position && p.status === "convocat"
        ).length;

        // pentru limită rezerve
        const reservesCount = players.filter(p => p.is_substitute === 1).length;

        const target = players.find(p => p.id === id);
        if (!target) return;

        // -----------------------
        // 0. Regula "11 titulari" — DOAR pt click din sidebar (fără force)
        // -----------------------
        if (!opts.force && field === "position" && startersCount >= PLAYERS_COUUNT) {
            if (reservesCount >= SUBSTITUTE_COUNT) {
                alert("Ai deja 11 titulari și 9 rezerve. Nu mai poți adăuga rezerve.");
                return;
            }
            const updated = players.map(p => {
                if (p.id !== id) return p;
                // îl facem rezervă; nu îi setăm poziția aici
                return { ...p, is_substitute: 1, status: "convocat", position: null };
            });
            this.setState({ players: updated, isModified: true });
            return;
        }

        // -----------------------
        // 1. Modificare poziție
        // -----------------------
        if (field === "position") {
            // Remove position
            if (value === null) {
                const updated = players.map(p => {
                    if (p.id !== id) return p;
                    const next = { ...p, position: null };
                    if (next.is_substitute !== 1) next.status = "neconvocat";
                    return next;
                });
                this.setState({ players: updated, isModified: true });
                return;
            }

            // Titular existent pe poziția aleasă
            const incumbent = players.find(
                p => p.position === value && p.id !== id && p.is_substitute !== 1
            );
            const prevStatus = target.status ?? null;
            const prevIsSub = target.is_substitute ? 1 : 0;

            if (incumbent) {
                const updated = players.map(p => {
                    if (p.id === id) {
                        return { ...p, position: value, status: "convocat", is_substitute: 0 };
                    }
                    if (p.id === incumbent.id) {
                        return { ...p, position: null, status: prevStatus, is_substitute: prevIsSub };
                    }
                    return p;
                });
                this.setState({ players: updated, isModified: true });
                return;
            }

            // Poziție liberă — normal sau cu force:true
            const updated = players.map(p => {
                if (p.id !== id) return p;
                return { ...p, position: value, status: "convocat", is_substitute: 0 };
            });
            this.setState({ players: updated, isModified: true });
            return;
        }

        // -----------------------
        // 2. Toggle rezervă
        // -----------------------
        if (field === "is_substitute") {
            if (!opts.force && value === 1 && reservesCount >= SUBSTITUTE_COUNT) {
                alert("Ai deja 9 rezerve. Nu mai poți adăuga.");
                return;
            }
            const val = value ? 1 : 0;
            const updated = players.map(p => {
                if (p.id !== id) return p;
                const next = { ...p, is_substitute: val };
                if (val === 1) next.status = "convocat";
                else if (!next.position) next.status = "neconvocat";
                return next;
            });
            this.setState({ players: updated, isModified: true });
            return;
        }

        // -----------------------
        // 3. Alte câmpuri
        // -----------------------
        const updated = players.map(p => (p.id === id ? { ...p, [field]: value } : p));
        this.setState({ players: updated, isModified: true });
    };

    handlePlayerChange = (id, field, value, opts = {}) => {
        const players = this.state.players;
        const startersCount = players.filter(
            p => p.is_substitute === 0 && p.position && p.status === "convocat"
        ).length;
        const reservesCount = players.filter(p => p.is_substitute === 1).length;

        const target = players.find(p => p.id === id);
        if (!target) return;

        // -----------------------
        // REGULA DOAR PENTRU SIDEBAR (fără force):
        // Dacă avem deja 11 titulari...
        // -----------------------
        if (!opts.force && field === "position" && startersCount >= PLAYERS_COUUNT) {
            // Dacă target e REZERVĂ și încearcă să ocupe o poziție DEJA OCUPATĂ,
            // atunci facem SWAP între rezervă (target) și titularul de pe poziția aleasă.
            if (target.is_substitute === 1 && value) {
                const incumbent = players.find(
                    p => p.position === value && p.is_substitute === 0
                );

                if (incumbent) {
                    const targetPrevStatus = target.status ?? null;
                    const targetPrevIsSub = target.is_substitute ? 1 : 0; // (1)
                    const incumbentPrevStatus = incumbent.status ?? null;
                    const incumbentPrevIsSub = incumbent.is_substitute ? 1 : 0; // (0)

                    const swapped = players.map(p => {
                        if (p.id === target.id) {
                            // Rezerva devine titular pe poziția aleasă
                            return {
                                ...p,
                                position: value,
                                status: incumbentPrevStatus,   // SWAP status
                                is_substitute: incumbentPrevIsSub // SWAP is_substitute (devine 0)
                            };
                        }
                        if (p.id === incumbent.id) {
                            // Titularul devine rezervă și își pierde poziția
                            return {
                                ...p,
                                position: null,
                                status: targetPrevStatus,      // SWAP status
                                is_substitute: targetPrevIsSub // SWAP is_substitute (devine 1)
                            };
                        }
                        return p;
                    });
                    this.setState({ players: swapped, isModified: true });
                    return;
                }
            }

            // Altfel, nu facem swap (poziția e liberă sau target nu e rezervă).
            // În regim de 11 titulari deja, nu putem face încă un titular.
            // Încercăm să-l facem rezervă dacă nu depășim 9 rezerve.
            if (reservesCount >= SUBSTITUTE_COUNT) {
                alert("Ai deja 11 titulari și 9 rezerve. Nu mai poți adăuga rezerve.");
                return;
            }

            const makeReserve = players.map(p => {
                if (p.id !== id) return p;
                // dacă era deja rezervă, practic nu schimbăm nimic; dar forțăm status corect
                return { ...p, is_substitute: 1, status: "convocat", position: p.position ?? null };
            });
            this.setState({ players: makeReserve, isModified: true });
            return;
        }

        // -----------------------
        // 1) Modificare poziție (regula normală sau când opts.force=true)
        // -----------------------
        if (field === "position") {
            if (value === null) {
                const updated = players.map(p => {
                    if (p.id !== id) return p;
                    const next = { ...p, position: null };
                    if (next.is_substitute !== 1) next.status = "neconvocat";
                    return next;
                });
                this.setState({ players: updated, isModified: true });
                return;
            }

            const incumbent = players.find(
                p => p.position === value && p.id !== id && p.is_substitute !== 1
            );

            const prevStatus = target.status ?? null;
            const prevIsSub = target.is_substitute ? 1 : 0;

            if (incumbent) {
                const updated = players.map(p => {
                    if (p.id === id) {
                        return { ...p, position: value, status: "convocat", is_substitute: 0 };
                    }
                    if (p.id === incumbent.id) {
                        return { ...p, position: null, status: prevStatus, is_substitute: prevIsSub };
                    }
                    return p;
                });
                this.setState({ players: updated, isModified: true });
                return;
            }

            // Poziție liberă
            const updated = players.map(p => {
                if (p.id !== id) return p;
                return { ...p, position: value, status: "convocat", is_substitute: 0 };
            });
            this.setState({ players: updated, isModified: true });
            return;
        }

        // -----------------------
        // 2) Toggle rezervă (respectă limita de 9, exceptând force)
        // -----------------------
        if (field === "is_substitute") {
            if (!opts.force && value === 1 && reservesCount >= SUBSTITUTE_COUNT) {
                alert("Ai deja 9 rezerve. Nu mai poți adăuga.");
                return;
            }
            const val = value ? 1 : 0;
            const updated = players.map(p => {
                if (p.id !== id) return p;
                const next = { ...p, is_substitute: val };
                if (val === 1) next.status = "convocat";
                else if (!next.position) next.status = "neconvocat";
                return next;
            });
            this.setState({ players: updated, isModified: true });
            return;
        }

        // -----------------------
        // 3) Alte câmpuri
        // -----------------------
        const updated = players.map(p => (p.id === id ? { ...p, [field]: value } : p));
        this.setState({ players: updated, isModified: true });
    };


    // ########################

    handleGameChange = (fields) => {
        const updatedGame = { ...this.state.game };

        Object.keys(fields).forEach((key) => {
            const val = fields[key];

            switch (key) {
                case "home_away":
                    updatedGame.game_home_away = val.id;
                    break;
                case "game_type":
                    updatedGame.game_type = val.id;
                    break;

                // scor
                case "team_score":
                    updatedGame.game_team_score = val === "" ? null : Number(val);
                    break;
                case "opponent_score":
                    updatedGame.game_opponent_score = val === "" ? null : Number(val);
                    break;

                // adversar
                case "opponent":
                    updatedGame.game_opponent = val;
                    break;

                // data/ora
                case "date":
                    updatedGame.event_date = val;
                    break;
                case "time":
                    updatedGame.event_time = val;
                    break;

                // restul câmpurilor „nemutate” din schema ta
                case "location":
                    updatedGame.location = val;
                    break;
                case "description":
                    updatedGame.description = val;
                    break;

                default:
                    // fallback: dacă chiar trimiți un câmp deja „game_*”, îl copiem ca atare
                    updatedGame[key] = val;
                    break;
            }
        });

        this.setState({ game: updatedGame, isModified: true });
    };


    getNameAtPosition = (posCode) => {
        const found = this.state.players.find((p) => p.position === posCode);
        return found ? found.name : "";
    };

    setTshirtHovered = (position, hover) => {
        this.setState({ tshirtHoveredPosition: hover ? position : null });
    };

    setPlayerHovered = (player, hover) => {
        this.setState({ hoveredPlayer: hover ? player : null });
    };

    // onSave = async () => {
    //     const { game, players, originalGame, originalPlayers } = this.state;
    //     try {
    //         // Save general game details if changed
    //         if (JSON.stringify(game) !== JSON.stringify(originalGame)) {
    //             const res = await fetch(`${BASE_API}/api/event/${game.event_id}`, {
    //                 method: "PATCH",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify(game)
    //             });
    //             if (!res.ok) throw new Error("Eroare la salvarea meciului");
    //         }

    //         // Prepare updated players
    //         const playerUpdates = players.map(p => ({
    //             player_id: p.id,
    //             position: p.position,
    //             is_substitute: p.is_substitute,
    //             minutes_played: p.minutes_played,
    //             rating: p.rating,
    //             status: p.status || 'neconvocat'
    //         }));

    //         if (playerUpdates.length > 0) {
    //             const res = await fetch(`${BASE_API}/api/game/${game.event_id}/players`, {
    //                 method: "PATCH",
    //                 headers: { "Content-Type": "application/json" },
    //                 body: JSON.stringify({ players: playerUpdates })
    //             });
    //             if (!res.ok) throw new Error("Eroare la salvarea jucătorilor");
    //         }

    //         this.setState({
    //             isModified: false,
    //             originalGame: { ...game },
    //             originalPlayers: [...players]
    //         });
    //         alert("Salvat cu succes!");
    //     } catch (err) {
    //         console.error("Eroare la salvare:", err);
    //         alert(`Eroare la salvare: ${err.message}`);
    //     }
    // };

    // 1) Mapper: din this.state.game -> payload-ul folosit de API
    buildGamePayload = () => {
        const { game, team } = this.state;
        console.log(this.state)

        const team_score = game.game_team_score === "" || game.game_team_score == null
            ? null
            : Number(game.game_team_score);
        const opponent_score = game.game_opponent_score === "" || game.game_opponent_score == null
            ? null
            : Number(game.game_opponent_score);

        let result = null;
        if (team_score !== null && opponent_score !== null) {
            if (team_score > opponent_score) result = "W";
            else if (team_score === opponent_score) result = "D";
            else result = "L";
        }

        return {
            // același format ca în componenta existentă
            team_id: team?.id || game.team_id,
            type: "game",
            date: game.event_date || null,
            time_start: game.event_time || null,
            location: game.location || null,

            training_type: null,     // rămâne compatibil
            training_duration: null,
            description: game.description || null,

            opponent: game.game_opponent || null,
            home_away: game.game_home_away,                // e deja string ("acasa"/"deplasare")
            game_type: game.game_type,                     // id de tip (ex: "amical")

            team_score,
            opponent_score,
            result,
            captain_id: game?.captain_id
        };
    };

    // 2) Salvează info generale joc via PATCH, folosind payload-ul de mai sus
    saveGameGeneral = async () => {
        const { game } = this.state;
        const payload = this.buildGamePayload();

        const res = await fetch(`${BASE_API}/api/events/${game.event_id}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        if (!res.ok) {
            const j = await res.json().catch(() => ({}));
            throw new Error(j.error || "Eroare la salvarea informațiilor despre meci");
        }
    };

    // 3) Salvează TOȚI jucătorii (inclusiv status) – nu doar diferențele
    saveAllPlayers = async () => {
        const { game, players } = this.state;

        const payload = players.map(p => ({
            player_id: p.id,
            position: p.position || null,
            is_substitute: p.is_substitute ? 1 : 0,
            minutes_played: p.minutes_played || 0,
            rating: p.rating || 0,
            status: p.status || "neconvocat",
        }));

        const res = await fetch(`${BASE_API}/api/game/${game.event_id}/players`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ players: payload }),
        });

        if (!res.ok) {
            const j = await res.json().catch(() => ({}));
            throw new Error(j.error || "Eroare la salvarea jucătorilor");
        }
    };

    // 4) onSave: întâi general info, apoi jucătorii; apoi sync „original*” și curăță isModified
    // onSave_changed = async () => {
    //     try {
    //         await this.saveGameGeneral();   // info general joc
    //         await this.saveAllPlayers();    // toți jucătorii (cu status)

    //         this.setState(prev => ({
    //             originalGame: { ...prev.game },
    //             originalPlayers: prev.players.map(p => ({ ...p })),
    //             isModified: false,
    //         }));

    //         alert("Salvat cu succes!");
    //     } catch (err) {
    //         console.error("Eroare la salvare:", err);
    //         alert(err.message || "Eroare la salvare");
    //     }
    // };

    getPlayerAtPosition = (posCode) => {
        return this.state.players.find(p => p.position === posCode) || null;
    };

    openPlayerMenu = (posCode, e) => {
        const p = this.getPlayerAtPosition(posCode);
        if (!p) return; // nu deschide dacă nu e jucător pe poziție
        this.setState({
            contextPlayer: p,
            contextPos: { x: e.clientX, y: e.clientY }
        });
    };

    setCaptain = (playerId) => {
        // toggle: dacă e deja căpitan -> scoate
        const isSame = this.state.game?.captain_id === playerId;
        const nextCaptainId = isSame ? null : playerId;
        this.setState(prev => ({
            game: { ...prev.game, captain_id: nextCaptainId },
            isModified: true,
            contextPlayer: null
        }));
    };



    onSave = async () => {
        try {
            await this.saveGameGeneral();
            await this.saveAllPlayers();
            await this.saveGameStats();          // <- NOU

            this.setState(prev => ({
                originalGame: { ...prev.game },
                originalPlayers: prev.players.map(p => ({ ...p })),
                originalStats: JSON.parse(JSON.stringify(prev.stats)),
                isModified: false,
            }));
            alert("Salvat cu succes!");
        } catch (err) {
            console.error(err);
            alert(err.message || "Eroare la salvare");
        }
    };

    handleStatsChange = (updatedStats) => {
        this.setState({ stats: updatedStats, isModified: true });
    };

    saveGameStats = async () => {
        const { game, stats } = this.state;
        console.log(game)
        const payload = {
            goals: (stats.goals || []).map(g => ({
                minute: g.minute === "" ? null : Number(g.minute),
                scorer_id: g.scorer_id || null,
                assist_id: g.assist_id || null,
                method: g.method || "open_play",
                team_side: g.team_side || "home",
                is_own_goal: g.is_own_goal ? 1 : 0
            })),
            cards: (stats.cards || []).map(c => ({
                minute: c.minute === "" ? null : Number(c.minute),
                player_id: c.player_id || null,
                card_type: c.card_type || "yellow",
                reason: c.reason || null
            })),
            subs: (stats.subs || []).map(s => ({
                minute: s.minute === "" ? null : Number(s.minute),
                player_in_id: s.player_in_id || null,
                player_out_id: s.player_out_id || null
            })),
            appearances: (stats.appearances || []).map(a => ({
                player_id: a.player_id || null,
                start_minute: Number(a.start_minute ?? 0),
                end_minute: Number(a.end_minute ?? 90),
                rating: Number(a.rating ?? 0)
            })),
            goals_against: (stats.goals_against || []).map(g => ({
                minute: Number(g.minute),                         // UI-ul validează 0..120
                stoppage: g.stoppage === "" ? null : Number(g.stoppage),
                method: g.method || null,
                notes: g.notes || null,
            })),
        };

        const r = await fetch(`${BASE_API}/api/game/${game.event_id}/stats`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        if (!r.ok) throw new Error((await r.json().catch(() => ({}))).error || "Eroare la salvarea statisticilor");
    };


    render() {
        console.log('State....', this.state)
        const { team, game, players, isModified, error, loading, tshirtHoveredPosition, hoveredPlayer } = this.state;

        let captain_id = game?.captain_id;
        console.log('3333333333', captain_id)
        if (loading) return <Spinner />;
        if (error) return <div className="bp5-text-danger">{error}</div>;

        return (
            <div className="field-container p-top-1-rem transparent-box" id='gameWrapper'>
                <LayoutDualSidebar
                    LeftSidebar={
                        <GameInfoPlayers
                            game={game}
                            team={team}
                            players={players}
                            onChange={this.handlePlayerChange}
                            setPlayerHovered={this.setPlayerHovered}
                            tshirtHoveredPosition={tshirtHoveredPosition}
                        />
                    }
                    RightSidebar={
                        <>
                            <>
                                <h3 className="section-title"  >
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <span style={{ order: game?.game_home_away == "acasa" ? 1 : 3 }}>{team?.name}</span>
                                        <span style={{ order: 2 }}> - </span>
                                        <span style={{ order: game?.game_home_away == "acasa" ? 3 : 1 }}>{game?.game_opponent}</span>
                                    </div>

                                </h3>
                                <div className='card-section'>
                                    <GameInfoGeneral game={game} onChange={this.handleGameChange} />
                                </div>
                            </>
                            <GameInfoStats players={players.filter(p => p.status == 'convocat')} stats={this.state.stats} onChange={this.handleStatsChange} />
                        </>
                    }
                >
                    <div className="training-players-col">
                        <div className='team-content field-width'>
                            <div className='header-row-l2 field-width'>
                                <h1 class="match-title  on-dark">
                                    <span class="team  team--emph" style={{ order: game?.game_home_away == "acasa" ? 1 : 3 }}>{team?.name}</span>
                                    <span class="dash" style={{ order: 2 }}>-</span>
                                    <span class="team" style={{ order: game?.game_home_away == "acasa" ? 3 : 1 }}>{game?.game_opponent}</span>
                                </h1>
                                {/* <div className='team-title field-width' style={{ display: 'flex' }}>
                                    <span style={{ order: game?.game_home_away == "acasa" ? 1 : 3 }}>{team?.name}</span>
                                    <span style={{ order: 2 }}> - </span>
                                    <span style={{ order: game?.game_home_away == "acasa" ? 3 : 1 }}>{game?.game_opponent}</span>

                                </div> */}
                                {/* <div className='f-3'>Sistem: {this.state.sistem}</div> */}
                                <div className='p-block'>
                                    <span className='f-4'>Sistem</span>
                                    <UISelect
                                        items={SISTEMS?.map(t => ({ id: t.id, name: t.name }))}
                                        selectedItem={SISTEMS.filter( v => v.id == this.state.sistem)[0]}
                                        onItemSelect={(v) => this.setState({sistem: v.name})}
                                        placeholder="Alege sistem..."
                                        filterable={false}
                                        className='select-transparent'
                                    // popoverProps={{ usePortal: false }}
                                    />
                                </div>
                            </div>
                            {POSITIONS[this.state.sistem].map((pos, index) => {
                                const isHovered = tshirtHoveredPosition === pos.position || hoveredPlayer === pos.position;
                                const isSelected = !!this.getNameAtPosition(pos.position);
                                const tshirtClass = isHovered ? 'orange-shirt' : isSelected ? 'blue-shirt' : '';
                                return (
                                    <div
                                        key={index}
                                        className={`player-box ${tshirtClass}`}
                                        style={{ top: pos.top, left: pos.left }}
                                        onMouseEnter={() => this.setTshirtHovered(pos.position, true)}
                                        onMouseLeave={() => this.setTshirtHovered(pos.position, false)}
                                        onClick={(e) => this.openPlayerMenu(pos.position, e)}
                                    >
                                        {pos.number}
                                        <span>{this.getNameAtPosition(pos.position)}</span>
                                        {/* Badge mic pentru căpitan, dacă vrei vizual */}
                                        {(() => {
                                            const p = this.getPlayerAtPosition(pos.position);
                                            console.log('position player', p)
                                            // this.state.game?.captain_id === p.id || 
                                            return p && (p.id === captain_id) ? (
                                                <span className="captain-badge">C</span>
                                            ) : null;
                                        })()}
                                    </div>
                                );
                            })}

                        </div>

                        <div className="blue-overlay-box">
                            <div className='field-wrapper field-width'>
                                <div className='goal-arrea'></div>
                                <div className='penalty-arrea'></div>
                                <div className='center-arrea'>
                                    <div className='center-circle'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LayoutDualSidebar>

                <SaveBar
                    visible={isModified}
                    onSave={this.onSave}
                    onCancel={() => this.setState({
                        players: [...this.state.originalPlayers],
                        game: { ...this.state.originalGame },
                        isModified: false
                    })}
                />

                {this.state.contextPlayer && this.state.contextPos && (
                    <div
                        className="ucl-menu-backdrop"
                        onClick={() => this.setState({ contextPlayer: null })}
                    >
                        <div
                            className="ucl-menu"
                            style={{ top: this.state.contextPos.y, left: this.state.contextPos.x }}
                            onClick={(e) => e.stopPropagation()}
                            role="menu"
                        >
                            <div className="ucl-menu-header">
                                <div className="ucl-avatar">
                                    {(this.state.contextPlayer.name || "?").slice(0, 1)}
                                </div>
                                <div className="ucl-meta">
                                    <div className="ucl-name">{this.state.contextPlayer.name}</div>
                                    <div className="ucl-sub">
                                        {this.state.contextPlayer.position || "Fără poziție"} ·{" "}
                                        {this.state.contextPlayer.is_substitute ? "Rezervă" : "Jucător"}
                                    </div>
                                </div>
                            </div>

                            <div className="ucl-divider" />

                            {/* Singura opțiune: Este căpitan */}
                            <div className="ucl-actions">
                                <label className="ucl-action">
                                    <input
                                        type="checkbox"
                                        checked={this.state.game?.captain_id === this.state.contextPlayer.id}
                                        onChange={() => this.setCaptain(this.state.contextPlayer.id)}
                                    />
                                    <span style={{ marginLeft: 8 }}>Este căpitan</span>
                                </label>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        );
    }
}